export default __webpack_public_path__ + "static/media/3d-tiles.9a29bb6e.webp";